module.exports = __webpack_public_path__ + "media/images/logo-83f7f9e9a40d966f68e7b12d46aaf3b29d8a358690ba7fb2b92920ae51a5e22d.jpg";